export class Term {
    id : number;
    name : string;
    slug : string;
    category : string;
    type : string;
}